import * as React from 'react';
export var IconCheckmark = React.forwardRef(function IconCheckmark({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M12.75 4.19a.75.75 0 0 1 .06 1.06l-5.8 6.5a.75.75 0 0 1-1.07.05l-2.7-2.5a.75.75 0 1 1 1.02-1.1l2.139 1.98 5.291-5.93a.75.75 0 0 1 1.06-.06Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M18.73 6.174a.75.75 0 0 1 .096 1.056l-8.75 10.5a.75.75 0 0 1-1.152 0l-3.75-4.5a.75.75 0 1 1 1.152-.96L9.5 16.078l8.174-9.808a.75.75 0 0 1 1.056-.096Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M18.73 6.174a.75.75 0 0 1 .096 1.056l-8.75 10.5a.75.75 0 0 1-1.152 0l-3.75-4.5a.75.75 0 1 1 1.152-.96L9.5 16.078l8.174-9.808a.75.75 0 0 1 1.056-.096Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
